import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-172" data-mp="21x25kbat0z3c">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-gold/30 border-l-4 border-l-gold bg-navy p-4 pr-10 text-ivory shadow-2xl shadow-black/50" aria-live="polite" data-id="element-173" data-mp="21yvddtx5lpcx">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-ivory/70 transition-colors duration-150 ease-out hover:text-ivory focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label="Chiudi avviso" data-id="element-174" data-mp="hk35ru5342vi">
            <XIcon className="h-4 w-4" data-id="element-175" data-mp="1jeydcbmawitw" />
          </button>
          <div className="flex gap-3" data-id="element-176" data-mp="1ng1qgqcys0rf">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-177" data-mp="1nf05nu65bzwi" />
            <div data-id="element-178" data-mp="19o3qp6557h7x">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-gold" data-id="element-179" data-mp="19nlidb57hcjn">Accesso confermato</p>
              <p className="mt-1 text-sm leading-snug text-ivory/80" data-id="element-180" data-mp="zrijce5nhu0x">
                Una volta completato l&apos;acquisto riceverai la
                <br data-id="element-181" data-mp="14rd748u4q3hr" />
                <span className="font-bold text-ivory" data-id="element-182" data-mp="14qldv4o08hun">SCIENZE FORENSI — Edizione Docenti</span>
              </p>
              <p className="mt-2 text-xs text-ivory/70" data-id="element-183" data-mp="qsnbyyqvedw1">Accesso digitale immediato via email.</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}